var createEnableOverlay = require('ui/createEnableOverlay')
  , tmpl = require('./tmpl.handlebars')

module.exports = createEnableOverlay(tmpl)
